/**
 * Zone utility functions
 */

// Zone ID constants
export const ZONE_IDS = {
    ORANG_LAUT: '4.1',
    MARKET_TRADERS: '4.2',
    BADANG: '4.4',
    BOOK_OF_MYTHS: '5.0',
    SG60: '7.0',
    PERANAKAN_DESIGN: '10.3',
    TIME_CAPSULE: '15.7',
} as const;

/**
 * Get the display name for a zone ID
 * @param zoneId - The zone ID (e.g., '4.1', '4.2')
 * @returns The formatted display name (e.g., 'Orang Laut (4.1)')
 */
export const getZoneDisplayName = (zoneId: string): string => {
    switch (zoneId) {
        case ZONE_IDS.ORANG_LAUT: return 'Orang Laut (4.1)';
        case ZONE_IDS.MARKET_TRADERS: return 'Market Traders (4.2)';
        case ZONE_IDS.BADANG: return 'Badang (4.4)';
        case ZONE_IDS.BOOK_OF_MYTHS: return 'Book of Myths (5.0)';
        case ZONE_IDS.SG60: return 'SG60 (7.0)';
        case ZONE_IDS.PERANAKAN_DESIGN: return 'Peranakan Design (10.3)';
        case ZONE_IDS.TIME_CAPSULE: return 'Time Capsule (15.7)';
        default: return `Zone ${zoneId}`;
    }
};

/**
 * Get the exhibit name from zone ID (without zone number)
 * @param zoneId - The zone ID (e.g., '4.1', '4.2')
 * @returns The exhibit name (e.g., 'Orang Laut')
 */
export const getExhibitNameFromZoneId = (zoneId: string): string => {
    switch (zoneId) {
        case ZONE_IDS.ORANG_LAUT: return 'Orang Laut';
        case ZONE_IDS.MARKET_TRADERS: return 'Market Traders';
        case ZONE_IDS.BADANG: return 'Badang';
        case ZONE_IDS.BOOK_OF_MYTHS: return 'Book of Myths';
        case ZONE_IDS.SG60: return 'SG60';
        case ZONE_IDS.PERANAKAN_DESIGN: return 'Peranakan Design';
        case ZONE_IDS.TIME_CAPSULE: return 'Time Capsule';
        default: return `Zone ${zoneId}`;
    }
};

/**
 * Get zone ID from exhibit ID
 * @param exhibitId - The exhibit ID (e.g., 'orang-laut', 'market-traders')
 * @returns The zone ID (e.g., '4.1', '4.2') or null if not found
 */
export const getZoneIdFromExhibitId = (exhibitId: string): string | null => {
    switch (exhibitId) {
        case 'orang-laut': return ZONE_IDS.ORANG_LAUT;
        case 'market-traders': return ZONE_IDS.MARKET_TRADERS;
        case 'badang': return ZONE_IDS.BADANG;
        case 'book-of-myths': return ZONE_IDS.BOOK_OF_MYTHS;
        case 'sg60': return ZONE_IDS.SG60;
        case 'peranakan-design': return ZONE_IDS.PERANAKAN_DESIGN;
        case 'time-capsule': return ZONE_IDS.TIME_CAPSULE;
        default: return null;
    }
}; 